import styled from '@emotion/styled';
import { Button } from '@lbcamden/lib-react';

export const PersonSearchResultsRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(8)};
  padding: ${({ theme }) => theme.spacing([6, 0, 8])};
`;

export const NewRecordButton = styled(Button)`
  display: inline-flex;
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
  border: 0;
`;
